export const APP_CONFIG = {
    appTitle: 'price forecasting hub',
    appVersion: "5.0.0",
    dbVersion: "3.0.1",
    contentContactURL: "http://upstream.chevron.com/northamerica/default.aspx",
    technicalContactURL: "https://chevron.service-now.com/itserviceportal?id=sc_cat_item_guide&sys_id=2d6bbc061b92d094b55adb1fdc4bcba5"
};
